// Telegram bot — xizmat sahifasi kontenti (Innobek)
// SEO: "Telegram bot yaratish", "bot yasash narxi", "buyurtma qabul qiluvchi bot",
// "Telegram Mini App", "Payme Click bot", "xodimlar uchun ichki bot".
// Asosiy xabar: bot — o'yinchoq emas, mijoz allaqachon turgan joyda ishlaydigan ish quroli.

const uz = {
    meta: {
        title: "Telegram bot yaratish — buyurtma, to'lov va integratsiya, 9 mln so'mdan",
        description:
            "Telegram bot ishlab chiqish: buyurtma qabul qilish, Payme va Click to'lovi, CRM integratsiyasi, ichki bot va Mini App. 9 mln so'mdan, 2–3 haftada ishga tushadi.",
        keywords: [
            "Telegram bot yaratish",
            "Telegram bot narxi",
            "bot ishlab chiqish",
            "buyurtma qabul qiluvchi bot",
            "Telegram Mini App",
            "Payme Click bot to'lov",
            "xodimlar uchun ichki bot",
            "Telegram bot Toshkent",
            "bot CRM integratsiya",
        ],
    },

    hero: {
        eyebrow: "Telegram bot",
        h1: "Telegram bot yaratish — mijoz allaqachon turgan joyda ishlaydigan kanal",
        lead:
            "Mijozingizni yangi ilova o'rnatishga ko'ndirish qiyin. Telegram esa uning telefonida allaqachon bor. Biz bot quramiz: buyurtma tugmalar orqali rasmiylashtiriladi, to'lov Payme yoki Click bilan o'tadi, har bir murojaat esa admin panelda qayd bo'ladi.",
        ctaPrimary: "Bepul konsultatsiya olish",
        ctaSecondary: "Narxlarni ko'rish",
        proof: [
            "200+ topshirilgan loyiha",
            "2–3 haftada ishga tushadi",
            "Payme va Click to'lovlari",
            "Kod va baza to'liq sizniki",
        ],
    },

    intro: {
        h: "Telegram bot nima va u nega O'zbekistonda eng tez ishlaydigan kanal?",
        p: [
            "Telegram bot — messenjer ichida ishlaydigan dastur. Foydalanuvchi hech narsa o'rnatmaydi, ro'yxatdan o'tmaydi va parol o'ylab topmaydi. U botni ochadi, tugmalarni bosadi va ishini bitiradi: mahsulot buyuradi, navbatga yoziladi, buyurtma holatini tekshiradi yoki kerakli hujjatni oladi.",
            "O'zbekistonda bu format alohida kuchli, chunki Telegram deyarli har bir telefonda bor va odamlar unda kuniga bir necha soat o'tkazadi. Mobil ilovada eng qimmat bosqich — o'rnatishga ko'ndirish. Botda bu bosqich umuman yo'q: havola bosiladi va mijoz ichkarida. Shuning uchun bot ko'pincha kompaniyaning birinchi va eng arzon raqamli kanali bo'ladi.",
            "Innobek botni chat-o'yinchoq sifatida emas, tizimning bir qismi sifatida quradi. Bot orqasida ma'lumotlar bazasi va admin panel turadi: buyurtmalar ro'yxatga tushadi, mahsulot va narxlarni o'zingiz tahrirlaysiz, statistika esa qaysi bo'lim ishlayotganini ko'rsatadi. Kerak bo'lsa botni CRM, 1C yoki omboringiz bilan bog'laymiz — shunda ma'lumot ikki joyda takrorlanmaydi.",
            "Bot bitta stsenariy bilan chegaralanmaydi. Mijozlar uchun buyurtma boti, xodimlar uchun ichki bot, kuryer uchun alohida rol va rahbar uchun kunlik hisobot — bularning hammasi bitta tizim ustida ishlashi mumkin. Katta interfeys kerak bo'lsa, Telegram Mini App ulaymiz: bu bot ichida ochiladigan to'liq veb-ilova, ya'ni katalogni tugmalar bilan emas, oddiy do'kon kabi ko'rasiz.",
            "Halol aytamiz: bot sehrli tugma emas va o'zi mijoz olib kelmaydi. Agar sizda auditoriya bo'lmasa — obunachi, mijozlar bazasi yoki reklama oqimi — bot bo'sh turadi. Bot mavjud oqimni tartibga soladi va qo'lda yozishishni tugatadi. Yana bir cheklov: bot Google'dan bepul trafik keltirmaydi va qidiruvda ko'rinmaydi. Shuning uchun uzoq muddatli marketing uchun sayt baribir kerak bo'ladi — bot uni almashtirmaydi, to'ldiradi.",
        ],
    },

    definition: {
        term: "Telegram bot nima?",
        text:
            "Telegram bot — messenjer ichida ishlaydigan avtomatik dastur bo'lib, foydalanuvchi hech narsa o'rnatmasdan buyurtma berishi, to'lov qilishi va ma'lumot olishi mumkin. Biznes tomonida u admin panel va ma'lumotlar bazasiga bog'lanadi, shu sababli har bir murojaat yozib boriladi.",
    },

    included: {
        eyebrow: "Nimalar kiradi",
        h: "Har bir tarifga standart tarzda kiradi",
        sub: "Bular keyin alohida hisob chiqadigan «qo'shimcha» emas — eng bazaviy tarifda ham bor.",
        items: [
            "Bepul konsultatsiya va bot stsenariysini chizish",
            "BotFather'da ro'yxatdan o'tkazish, nom va tavsif sozlash",
            "Tugmalar tuzilmasi va barcha xabar matnlari",
            "O'zbek va rus tilidagi interfeys",
            "Admin panel: murojaatlar, matnlar va sozlamalar",
            "Serverga o'rnatish, HTTPS webhook va domen",
            "Har kunlik avtomatik zaxira nusxa (backup)",
            "Haqiqiy foydalanuvchilarda sinov va tuzatish",
            "Botni boshqarish bo'yicha video-qo'llanma",
            "Git repozitoriysi va kodning to'liq mulkchiligi",
            "Bot to'xtab qolsa xabar beradigan monitoring",
            "Ishga tushgandan keyin 6 oylik texnik qo'llab-quvvatlash",
        ],
    },

    benefits: {
        eyebrow: "Nega kerak",
        h: "Telegram bot biznesga nima beradi",
        sub: "Bot — kichik byudjet bilan katta qo'l mehnatini yopadigan kanal. Quyida u aniq nimani hal qiladi.",
        items: [
            {
                t: "Buyurtma qo'lda yozishmasdan keladi",
                d: "Mijoz tugmalar orqali mahsulotni tanlaydi, manzilni yuboradi va buyurtmani tasdiqlaydi. Menejer «nechta kerak edi?» deb qayta so'ramaydi — ariza to'liq va bir xil shaklda admin panelga tushadi.",
            },
            {
                t: "Xabar yuborish tekin",
                d: "SMS har bir xabar uchun pul oladi, bot esa yo'q. Aksiya, buyurtma holati yoki eslatmani mingta obunachiga yuborish xarajatsiz. Segment bo'yicha ham yuborish mumkin: faqat sotib olganlarga yoki faqat bir hududdagilarga.",
            },
            {
                t: "Kirish to'sig'i yo'q",
                d: "Ilova o'rnatish, ro'yxatdan o'tish va parol tiklash bosqichlari umuman yo'q. Reklamadagi havoladan botgacha bitta bosish. Shuning uchun botda konversiya ko'pincha saytdagidan yuqori chiqadi.",
            },
            {
                t: "To'lov shu yerda yopiladi",
                d: "Payme va Click bot ichida ulanadi: mijoz boshqa saytga o'tmaydi va karta ma'lumotini sizga bermaydi. To'lov o'tgani haqidagi javob avtomatik keladi, buyurtma holati esa o'zi yangilanadi.",
            },
            {
                t: "Xodimlar ham botdan ishlaydi",
                d: "Ichki bot ta'til arizasi, davomat, vazifa taqsimoti va kunlik hisobotni yopadi. Yangi tizim o'rgatish shart emas — xodim allaqachon Telegram'da o'tiradi va interfeysni biladi.",
            },
            {
                t: "24/7 ishlaydi",
                d: "Kechasi kelgan savol javobsiz qolmaydi: bot narx, manzil va ish vaqtini o'zi aytadi, murakkab so'rovni esa menejerga uzatadi. Ertalab jamoa tayyor ariza ro'yxatini ko'radi.",
            },
            {
                t: "Tizim bilan bitta bazada",
                d: "Bot CRM, 1C yoki ombor bilan bog'lanadi. Mahsulot qoldig'i bitta joyda turadi, buyurtma esa avtomatik CRM'ga tushadi — menejer ma'lumotni qo'lda ko'chirib o'tirmaydi.",
            },
            {
                t: "Tez sinov maydoni",
                d: "Yangi mahsulot yoki xizmatni bozorda tekshirish uchun bot eng arzon yo'l. 2–3 haftada ishga tushadi, talab bo'lmasa katta pul yo'qotmaysiz, bo'lsa — shu tizim ustiga sayt va ilova quriladi.",
            },
        ],
    },

    audience: {
        eyebrow: "Kimlar qiladi",
        h: "Qanaqa bizneslarga Telegram bot mos keladi",
        sub: "Mijoz bilan tez-tez muloqot qiladigan va buyurtmani qo'lda yuritish og'irlashgan sohalar.",
        items: [
            {
                t: "Kafe, restoran va yetkazib berish",
                d: "Menyu, savat, joylashuv, to'lov va buyurtma holati bot ichida. Kuryer uchun alohida rol qo'shiladi.",
            },
            {
                t: "Do'kon va onlayn savdo",
                d: "Katalog, narx, qoldiq va aksiyalar. Sayt qurmasdan sotishni boshlash yoki mavjud do'konga ikkinchi kanal qo'shish.",
            },
            {
                t: "Xizmat ko'rsatish sohasi",
                d: "Salon, klinika, avtoservis: navbatga yozilish, eslatma va takroriy tashrif taklifi.",
            },
            {
                t: "Ta'lim markazlari",
                d: "Kursga ariza, jadval, davomat, uy vazifasi va to'lov eslatmasi bitta botda.",
            },
            {
                t: "Ichki korporativ bot",
                d: "Ta'til va avans arizasi, kunlik hisobot, vazifa taqsimoti hamda ombordan so'rov — xodimlar uchun.",
            },
            {
                t: "Kanal va hamjamiyat egalari",
                d: "Obunani tekshirish, kontent tarqatish, so'rovnoma va reklama joylashuvini nazorat qilish.",
            },
            {
                t: "Logistika va servis xizmatlari",
                d: "Ariza qabul qilish, brigadaga biriktirish, holat yangilanishi va mijozga avtomatik xabar.",
            },
        ],
    },

    pricing: {
        eyebrow: "Narxlar",
        h: "Telegram bot narxi — uchta tarif",
        sub: "Narxlar oshkora va bir martalik. Foydalanuvchi soni yoki yuborilgan xabar uchun qo'shimcha haq olinmaydi.",
        note:
            "Yakuniy hisob-kitob bepul konsultatsiyadan keyin, funksiyalar ro'yxatiga qarab tasdiqlanadi. To'lov bosqichma-bosqich: avans va yakuniy topshirish. Server (bulut) xarajati narxga kirmaydi — oddiy bot uchun odatda oyiga 150–400 ming so'm. Payme va Click komissiyasi to'g'ridan-to'g'ri provayderga to'lanadi. Savol bo'lsa qo'ng'iroq qiling: +998 90 954 12 62.",
        tiers: [
            {
                name: "Start",
                tagline: "Ariza va ma'lumot boti",
                price: "9 000 000",
                priceNote: "so'mdan",
                term: "2–3 hafta",
                best: "Murojaatlarni tartibga solish va kanalni tez ochish",
                features: [
                    "Tugmali menyu va suhbat stsenariysi",
                    "Xizmatlar, narxlar, manzil va ish vaqti bo'limlari",
                    "Ariza qabul qilish: ism, telefon, so'rov matni",
                    "Menejerga darhol bildirishnoma yuborish",
                    "O'zbek va rus tilidagi interfeys",
                    "Admin panel: arizalar ro'yxati va matnlarni tahrirlash",
                    "Barcha obunachilarga ommaviy xabar yuborish",
                    "Oddiy statistika: foydalanuvchilar, arizalar, faol bo'limlar",
                    "Serverga o'rnatish, monitoring va ishga tushirish",
                    "O'qitish hamda 6 oylik texnik qo'llab-quvvatlash",
                ],
            },
            {
                name: "Business",
                tagline: "Katalog, to'lov va integratsiya",
                price: "24 000 000",
                priceNote: "so'mdan",
                term: "4–7 hafta",
                best: "Bot orqali to'liq sotuv va buyurtma oqimini yo'lga qo'yish",
                featured: true,
                features: [
                    "Start tarifidagi barcha imkoniyatlar",
                    "Mahsulot katalogi: kategoriya, rasm, narx, qidiruv",
                    "Savat va buyurtmani bosqichma-bosqich rasmiylashtirish",
                    "Payme va Click orqali bot ichida onlayn to'lov",
                    "Yetkazib berish manzili va joylashuvni yuborish",
                    "Buyurtma holatini kuzatish va avtomatik xabarlar",
                    "Sodiqlik: promokod, chegirma va ballar tizimi",
                    "CRM, 1C yoki Google Sheets bilan integratsiya",
                    "Segmentlar bo'yicha xabar yuborish va natija hisoboti",
                    "Kengaytirilgan admin panel: buyurtmalar, mahsulotlar, hisobotlar",
                ],
            },
            {
                name: "Individual",
                tagline: "Mini App va murakkab yechim",
                price: "Kelishuv",
                priceNote: "asosida",
                term: "Loyihaga qarab",
                best: "Ko'p rolli botlar, Mini App va ichki tizimga ulanish",
                features: [
                    "Telegram Mini App — bot ichidagi to'liq veb-interfeys",
                    "Ko'p rolli bot: mijoz, kuryer, menejer, filial, rahbar",
                    "AI yordamchi: erkin yozilgan savollarga javob",
                    "ERP, ombor yoki ichki tizimlar bilan chuqur integratsiya",
                    "Ovozli xabar, rasm va hujjatlarni qayta ishlash",
                    "Kanal boshqaruvi: obunani tekshirish, avtomatik post, moderatsiya",
                    "Yuqori yuklamaga tayyorlash va ishlash monitoringi",
                    "Kelishilgan SLA bo'yicha doimiy qo'llab-quvvatlash",
                ],
            },
        ],
    },

    process: {
        eyebrow: "Jarayon",
        h: "Telegram bot qanday quriladi",
        sub: "Oltita bosqich. Kod yozishdan oldin bot qaysi vazifani yopishi qog'ozda aniqlanadi.",
        steps: [
            {
                t: "Vazifani aniqlash",
                time: "2–4 kun",
                d: "Bot nimani yopishi kerakligini belgilaymiz: ariza, sotuv, ichki jarayon yoki qo'llab-quvvatlash. Shu yerda ko'pincha ma'lum bo'ladiki, kerak bo'lgan narsa botning yarmi, qolgani esa ortiqcha.",
            },
            {
                t: "Stsenariy va matnlar",
                time: "3–6 kun",
                d: "Foydalanuvchi yo'lini chizamiz: qaysi tugma nima qiladi, qanday xabar chiqadi, xato holatda nima bo'ladi. Matnlar ikki tilda tayyorlanadi va siz tasdiqlaganingizdan keyin davom etamiz.",
            },
            {
                t: "Dasturlash",
                time: "1–4 hafta",
                d: "Bot, ma'lumotlar bazasi va admin panel quriladi. Katalog, savat va rollar shu bosqichda yoziladi. Har hafta ishlaydigan versiyani o'zingiz sinab ko'rasiz.",
            },
            {
                t: "To'lov va integratsiya",
                time: "3–10 kun",
                d: "Payme yoki Click ulanadi, CRM hamda 1C bilan almashuv sozlanadi. To'lov tizimida shartnoma va tekshiruv bosqichi bor — bu odatda eng ko'p kutiladigan qism.",
            },
            {
                t: "Sinov va ishga tushirish",
                time: "3–5 kun",
                d: "Bot serverga joylashtiriladi, webhook va monitoring yoqiladi. Avval kichik guruh sinab ko'radi, xatolar tuzatiladi, keyin bot barcha mijozlarga ochiladi.",
            },
            {
                t: "Kuzatuv va tuzatish",
                time: "6 oy",
                d: "Birinchi haftalarda odamlar qaysi bosqichda to'xtayotganini kuzatamiz. Statistikaga qarab menyu soddalashtiriladi, matnlar tuzatiladi va xatoliklar bepul bartaraf etiladi.",
            },
        ],
    },

    samples: {
        eyebrow: "Namunalar",
        h: "Biz qurgan botlar va tizimlar",
        sub: "Har bir loyiha noldan: stsenariy, admin panel va integratsiyalar biz tomonimizdan bajarilgan.",
        cta: "Barcha loyihalar",
        slugs: ["grandpharm", "tezlift", "besh-market-app", "firewise"],
    },

    faq: {
        eyebrow: "Savol-javob",
        h: "Ko'p beriladigan savollar",
        sub: "Telegram bot bo'yicha eng ko'p so'raladigan savollarga qisqa javoblar.",
        items: [
            {
                q: "Telegram bot yaratish qancha turadi?",
                a: "Narxlar 9 000 000 so'mdan boshlanadi. Bu summaga tugmali menyu, ma'lumot bo'limlari, ariza qabul qilish, ommaviy xabar va admin panel kiradi. Katalog, savat, Payme yoki Click to'lovi hamda CRM integratsiyasi qo'shilsa, narx 24 000 000 so'mdan boshlanadi. Mini App va ko'p rolli botlar kelishuv asosida hisoblanadi.",
            },
            {
                q: "Bot necha kunda tayyor bo'ladi?",
                a: "Start tarifi 2–3 haftada, Business tarifi 4–7 haftada ishga tushadi. Bu bizning eng tez xizmatimiz. Muddatni ko'pincha dasturlash emas, to'lov tizimini ulash cho'zadi: Payme va Click shartnoma hamda tekshiruvni talab qiladi, bu 3–10 kun oladi. Matnlarni tez tasdiqlasangiz, loyiha ham tez yopiladi.",
            },
            {
                q: "Bot uchun oylik to'lov bormi?",
                a: "Telegram botdan foydalanish bepul — Telegram sizdan pul olmaydi va yuborilgan xabar uchun ham haq yo'q. Yagona doimiy xarajat — bot joylashgan server: oddiy bot uchun odatda oyiga 150–400 ming so'm. Agar bot ichida to'lov qabul qilsangiz, Payme yoki Click komissiyasi alohida hisoblanadi.",
            },
            {
                q: "Bot ichida Payme va Click orqali to'lov qabul qilsa bo'ladimi?",
                a: "Ha, bu Business tarifiga kiradi. Mijoz botdan chiqmaydi: savatni tasdiqlaydi, to'lov oynasini ochadi va pul o'tgach buyurtma holati avtomatik yangilanadi. Karta ma'lumoti sizning serveringizga tushmaydi — u to'lov tizimida qoladi. Ulash ishlari narxga kiradi, komissiya esa provayderga to'g'ridan-to'g'ri to'lanadi. Naqd va yetkazib berishda to'lash varianti ham qoldiriladi.",
            },
            {
                q: "Botni CRM yoki 1C bilan bog'lash mumkinmi?",
                a: "Ha. Botdan kelgan buyurtma CRM'da bitim sifatida ochiladi, mijoz kartasiga esa aloqa tarixi yoziladi. 1C tomondan mahsulot qoldig'i va narxlar botga tushadi — shunda sotuvda yo'q mahsulot ko'rinmay qoladi. Google Sheets bilan ham ishlaymiz, agar hozircha CRM bo'lmasa va jadval yetarli bo'lsa.",
            },
            {
                q: "Telegram Mini App bilan oddiy botning farqi nima?",
                a: "Oddiy bot tugmalar va xabarlar bilan ishlaydi — bu tez, lekin katta katalogni ko'rish noqulay. Mini App esa bot ichida ochiladigan to'liq veb-interfeys: rasmli katalog, filtrlar, savat va bitta ekranda to'lov. Agar mahsulot 100 tadan oshsa yoki tanlash murakkab bo'lsa, Mini App tavsiya qilamiz.",
            },
            {
                q: "Bot orqali necha kishiga xabar yuborsa bo'ladi?",
                a: "Cheklov obunachilar soniga emas, tezlikka bog'liq: Telegram sekundiga taxminan 30 ta xabarni o'tkazadi, shuning uchun 10 ming obunachiga yuborish bir necha daqiqa davom etadi. Bizning tizim xabarlarni navbat bilan yuboradi va yetib borganini hisoblaydi. Muhim ogohlantirish: foydalanuvchilar spamdan shikoyat qilsa, Telegram botni cheklashi mumkin — shuning uchun xabarni segment bo'yicha yuborishni tavsiya qilamiz.",
            },
            {
                q: "Xodimlar uchun ichki bot nima qila oladi?",
                a: "Ta'til va avans arizasi, kunlik hisobot, vazifa taqsimoti, davomat qayd etish, ombordan mahsulot so'rash va rahbarga tezkor statistika. Afzalligi shundaki, xodim yangi dastur o'rganmaydi — u allaqachon Telegram'da. Rollar bo'yicha kirish sozlanadi: kim nimani ko'rishi va tasdiqlashi mumkinligini siz belgilaysiz.",
            },
            {
                q: "Bot sayt o'rnini bosa oladimi?",
                a: "Boshlanish uchun — ha, ayniqsa mijozlaringiz Telegram va Instagram'da bo'lsa. Lekin bot Google qidiruvida ko'rinmaydi va bepul trafik keltirmaydi. Sayt esa rasmiy ko'rinish beradi hamda yillar davomida mijoz olib keladi. Shuning uchun bot saytni almashtirmaydi — ko'p mijozimiz ikkalasini bitta bazada ishlatadi.",
            },
            {
                q: "Telegram bot qachon kerak emas?",
                a: "Agar sizda auditoriya bo'lmasa — obunachi, mijozlar bazasi yoki reklama oqimi yo'q bo'lsa — bot bo'sh turadi, chunki u o'zi mijoz olib kelmaydi. Shuningdek, mahsulot tanlash uzoq maslahat talab qilsa yoki har bitim individual kelishuvga tayansa, bot faqat birinchi aloqani yopadi, sotuvni emas.",
            },
        ],
    },

    cta: {
        h: "Botingiz qaysi vazifani yopishi kerak?",
        p: "Bepul konsultatsiyada bot nimani avtomatlashtirishi mumkinligini birga aniqlaymiz, ortiqcha funksiyalarni olib tashlaymiz va aniq narx bilan muddatni yozma ravishda beramiz. Majburiyat yo'q. Telefon: +998 90 954 12 62.",
        button: "Bepul konsultatsiya olish",
        secondary: "Telegram orqali yozish",
    },

    images: [
        {
            src: "/assets/img/projects/grandpharm.webp",
            alt: "Grandpharm uchun Telegram bot va logistika tizimi bitta ekotizimda",
            caption: "Grandpharm — Telegram bot, marshrutizatsiya va ichki boshqaruv tizimi bitta bazada ishlaydi.",
        },
        {
            src: "/assets/img/projects/tamamuzbot.webp",
            alt: "Tamam uz Telegram boti — katalog, savat va buyurtma rasmiylashtirish ekrani",
            caption: "Tamam uz — katalog, savat va buyurtma rasmiylashtirish to'liq bot ichida.",
        },
        {
            src: "/assets/img/projects/aslamboi-uc-bot.webp",
            alt: "Aslamboi UC Telegram boti orqali onlayn to'lov va avtomatik yetkazib berish",
            caption: "Aslamboi UC — to'lov bot ichida yopiladi, buyurtma esa avtomatik bajariladi.",
        },
        {
            src: "/assets/img/services/telegram-bot-admin-panel.webp",
            alt: "Telegram bot admin paneli: buyurtmalar ro'yxati, statistika va xabar yuborish bo'limi",
            caption: "Admin panel — buyurtmalar, mahsulotlar, obunachilar statistikasi va segmentli xabar yuborish.",
            prompt:
                "Clean modern web admin dashboard for a Telegram bot, light interface with soft blue accents, left sidebar navigation with icons, main area showing a table of incoming orders with status badges, a small line chart of daily active users, and a broadcast composer panel on the right. Realistic UI screenshot style, crisp typography, no readable brand names, 16:10 aspect ratio.",
        },
        {
            src: "/assets/img/services/telegram-bot-mini-app.webp",
            alt: "Telegram Mini App interfeysi — bot ichida ochiladigan rasmli mahsulot katalogi va savat",
            caption: "Telegram Mini App — bot ichida ochiladigan to'liq do'kon interfeysi: filtr, savat va to'lov.",
            prompt:
                "Smartphone mockup showing a Telegram Mini App opened inside the messenger: a product catalogue grid with photo cards, price tags, category filter chips at the top and a floating cart button at the bottom. Telegram-style blue header bar, clean minimal e-commerce UI, realistic phone screen render on a neutral studio background, vertical composition.",
        },
    ],

    related: ["crm-tizimlar", "ai-agent", "internet-dokonlar", "biznes-avtomatlashtirish"],
};

const ru = {
    meta: {
        title: "Разработка Telegram-бота — заказы, оплата и интеграции, от 9 млн сум",
        description:
            "Разработка Telegram-бота: приём заказов, оплата Payme и Click, интеграция с CRM, внутренний бот и Mini App. От 9 млн сум, запуск за 2–3 недели.",
        keywords: [
            "разработка Telegram-бота",
            "создать Telegram-бота",
            "Telegram-бот цена",
            "бот для приёма заказов",
            "Telegram Mini App",
            "оплата Payme Click в боте",
            "внутренний бот для сотрудников",
            "Telegram-бот Ташкент",
            "интеграция бота с CRM",
        ],
    },

    hero: {
        eyebrow: "Telegram-бот",
        h1: "Разработка Telegram-бота — канал там, где клиент уже находится",
        lead:
            "Убедить клиента установить новое приложение сложно. Telegram у него в телефоне уже есть. Мы строим бота: заказ оформляется кнопками, оплата проходит через Payme или Click, а каждое обращение фиксируется в админ-панели.",
        ctaPrimary: "Получить бесплатную консультацию",
        ctaSecondary: "Посмотреть цены",
        proof: [
            "200+ сданных проектов",
            "Запуск за 2–3 недели",
            "Оплата через Payme и Click",
            "Код и база полностью ваши",
        ],
    },

    intro: {
        h: "Что такое Telegram-бот и почему это самый быстрый канал в Узбекистане",
        p: [
            "Telegram-бот — программа, которая работает внутри мессенджера. Пользователю не нужно ничего устанавливать, регистрироваться и придумывать пароль. Он открывает бота, нажимает кнопки и решает задачу: заказывает товар, записывается на приём, проверяет статус заказа или получает нужный документ.",
            "В Узбекистане формат особенно силён: Telegram стоит практически на каждом телефоне, и люди проводят в нём по несколько часов в день. В мобильном приложении самый дорогой шаг — уговорить клиента его установить. В боте этого шага нет вовсе: одно нажатие на ссылку — и клиент внутри. Поэтому бот часто становится первым и самым дешёвым цифровым каналом компании.",
            "Innobek делает бота не чат-игрушкой, а частью системы. За ботом стоят база данных и админ-панель: заказы попадают в список, товары и цены вы редактируете сами, а статистика показывает, какой раздел действительно работает. При необходимости подключаем бота к CRM, 1С или складу — тогда данные не дублируются в двух местах.",
            "Бот не ограничен одним сценарием. Клиентский бот для заказов, внутренний бот для сотрудников, отдельная роль для курьера и ежедневный отчёт для руководителя могут работать на одной системе. Если нужен крупный интерфейс, подключаем Telegram Mini App: это полноценное веб-приложение внутри бота, где каталог выглядит как обычный магазин, а не как набор кнопок.",
            "Скажем честно: бот — не волшебная кнопка и сам клиентов не приводит. Если аудитории нет — ни подписчиков, ни базы, ни рекламного потока — бот будет стоять пустым. Он наводит порядок в существующем потоке и убирает ручную переписку. Ещё одно ограничение: бот не приносит бесплатный трафик из Google и не виден в поиске. Для долгого маркетинга сайт всё равно нужен — бот его не заменяет, а дополняет.",
        ],
    },

    definition: {
        term: "Что такое Telegram-бот?",
        text:
            "Telegram-бот — автоматическая программа внутри мессенджера, в которой пользователь без установки и регистрации оформляет заказ, оплачивает и получает информацию. Со стороны бизнеса бот подключён к админ-панели и базе данных, поэтому каждое обращение сохраняется.",
    },

    included: {
        eyebrow: "Что входит",
        h: "Входит в каждый тариф по умолчанию",
        sub: "Это не «допы», за которые потом выставят отдельный счёт, — всё есть и в базовом тарифе.",
        items: [
            "Бесплатная консультация и проработка сценария бота",
            "Регистрация в BotFather, настройка имени и описания",
            "Структура кнопок и все тексты сообщений",
            "Интерфейс на узбекском и русском языках",
            "Админ-панель: обращения, тексты и настройки",
            "Установка на сервер, HTTPS-webhook и домен",
            "Ежедневное автоматическое резервное копирование",
            "Тестирование на реальных пользователях и правки",
            "Видеоинструкция по управлению ботом",
            "Git-репозиторий и полное владение кодом",
            "Мониторинг с уведомлением, если бот перестал отвечать",
            "6 месяцев технической поддержки после запуска",
        ],
    },

    benefits: {
        eyebrow: "Зачем нужен",
        h: "Что Telegram-бот даёт бизнесу",
        sub: "Бот закрывает большой объём ручной работы при небольшом бюджете. Ниже — что именно он решает.",
        items: [
            {
                t: "Заказ приходит без переписки",
                d: "Клиент выбирает товар кнопками, отправляет адрес и подтверждает заказ. Менеджеру не нужно переспрашивать «сколько штук?» — заявка приходит в админ-панель заполненной и в едином формате.",
            },
            {
                t: "Рассылка бесплатна",
                d: "SMS берёт деньги за каждое сообщение, бот — нет. Акция, статус заказа или напоминание уходят тысяче подписчиков без затрат. Можно отправлять по сегментам: только покупавшим или только жителям одного района.",
            },
            {
                t: "Нет барьера входа",
                d: "Ни установки приложения, ни регистрации, ни восстановления пароля. От ссылки в рекламе до бота — одно нажатие. Поэтому конверсия в боте часто оказывается выше, чем на сайте.",
            },
            {
                t: "Оплата закрывается на месте",
                d: "Payme и Click подключаются внутри бота: клиент не уходит на другой сайт и не передаёт вам данные карты. Подтверждение оплаты приходит автоматически, а статус заказа обновляется сам.",
            },
            {
                t: "Сотрудники работают в том же боте",
                d: "Внутренний бот закрывает заявления на отпуск, посещаемость, распределение задач и ежедневный отчёт. Учить новую программу не нужно — сотрудник и так сидит в Telegram и знает интерфейс.",
            },
            {
                t: "Работает круглосуточно",
                d: "Вопрос, пришедший ночью, не остаётся без ответа: бот сам называет цену, адрес и часы работы, а сложный запрос передаёт менеджеру. Утром команда видит готовый список заявок.",
            },
            {
                t: "Одна база с вашей системой",
                d: "Бот связывается с CRM, 1С или складом. Остатки хранятся в одном месте, а заказ автоматически попадает в CRM — менеджеру не приходится переносить данные руками.",
            },
            {
                t: "Быстрая площадка для проверки",
                d: "Проверить новый товар или услугу дешевле всего через бота. Запуск за 2–3 недели: если спроса нет, вы не теряете крупный бюджет, если есть — поверх этой системы строятся сайт и приложение.",
            },
        ],
    },

    audience: {
        eyebrow: "Кому подходит",
        h: "Какому бизнесу подходит Telegram-бот",
        sub: "Сферам с постоянным потоком обращений, где вести заказы вручную стало тяжело.",
        items: [
            {
                t: "Кафе, рестораны и доставка",
                d: "Меню, корзина, геолокация, оплата и статус заказа внутри бота. Для курьера добавляется отдельная роль.",
            },
            {
                t: "Магазины и онлайн-торговля",
                d: "Каталог, цены, остатки и акции. Начать продавать без сайта или добавить второй канал к существующему магазину.",
            },
            {
                t: "Сфера услуг",
                d: "Салон, клиника, автосервис: запись, напоминания и предложение повторного визита.",
            },
            {
                t: "Учебные центры",
                d: "Заявка на курс, расписание, посещаемость, домашние задания и напоминания об оплате в одном боте.",
            },
            {
                t: "Внутренний корпоративный бот",
                d: "Заявления на отпуск и аванс, ежедневный отчёт, распределение задач и запросы на склад — для сотрудников.",
            },
            {
                t: "Владельцы каналов и сообществ",
                d: "Проверка подписки, раздача контента, опросы и контроль рекламных размещений.",
            },
            {
                t: "Логистика и сервисные службы",
                d: "Приём заявок, назначение бригады, обновление статуса и автоматическое сообщение клиенту.",
            },
        ],
    },

    pricing: {
        eyebrow: "Цены",
        h: "Стоимость Telegram-бота — три тарифа",
        sub: "Цены открытые, оплата разовая. Доплат за количество пользователей или отправленных сообщений нет.",
        note:
            "Окончательный расчёт подтверждается после бесплатной консультации и зависит от списка функций. Оплата поэтапная: аванс и финальная сдача. Стоимость сервера (облака) в цену не входит — для обычного бота это обычно 150–400 тысяч сум в месяц. Комиссия Payme и Click платится провайдеру напрямую. Вопросы — по телефону +998 90 954 12 62.",
        tiers: [
            {
                name: "Start",
                tagline: "Бот заявок и информации",
                price: "9 000 000",
                priceNote: "сум и выше",
                term: "2–3 недели",
                best: "Навести порядок в обращениях и быстро открыть канал",
                features: [
                    "Кнопочное меню и сценарий диалога",
                    "Разделы услуг, цен, адреса и графика работы",
                    "Приём заявок: имя, телефон, текст запроса",
                    "Мгновенное уведомление менеджеру",
                    "Интерфейс на узбекском и русском языках",
                    "Админ-панель: список заявок и редактирование текстов",
                    "Массовая рассылка всем подписчикам",
                    "Базовая статистика: пользователи, заявки, активные разделы",
                    "Установка на сервер, мониторинг и запуск",
                    "Обучение и 6 месяцев технической поддержки",
                ],
            },
            {
                name: "Business",
                tagline: "Каталог, оплата и интеграции",
                price: "24 000 000",
                priceNote: "сум и выше",
                term: "4–7 недель",
                best: "Наладить полноценные продажи и поток заказов через бота",
                featured: true,
                features: [
                    "Все возможности тарифа Start",
                    "Каталог товаров: категории, фото, цена, поиск",
                    "Корзина и пошаговое оформление заказа",
                    "Онлайн-оплата через Payme и Click внутри бота",
                    "Адрес доставки и отправка геолокации",
                    "Отслеживание статуса заказа и автоматические сообщения",
                    "Лояльность: промокоды, скидки и система баллов",
                    "Интеграция с CRM, 1С или Google Sheets",
                    "Рассылки по сегментам и отчёт по результатам",
                    "Расширенная админ-панель: заказы, товары, отчёты",
                ],
            },
            {
                name: "Индивидуально",
                tagline: "Mini App и сложные решения",
                price: "По договорённости",
                priceNote: "индивидуально",
                term: "По проекту",
                best: "Боты с несколькими ролями, Mini App и подключение к внутренним системам",
                features: [
                    "Telegram Mini App — полноценный веб-интерфейс внутри бота",
                    "Бот с несколькими ролями: клиент, курьер, менеджер, филиал, руководитель",
                    "ИИ-ассистент: ответы на свободно сформулированные вопросы",
                    "Глубокая интеграция с ERP, складом или внутренними системами",
                    "Обработка голосовых сообщений, изображений и документов",
                    "Управление каналом: проверка подписки, автопостинг, модерация",
                    "Подготовка к высоким нагрузкам и мониторинг работы",
                    "Постоянная поддержка по согласованному SLA",
                ],
            },
        ],
    },

    process: {
        eyebrow: "Процесс",
        h: "Как создаётся Telegram-бот",
        sub: "Шесть этапов. До написания кода на бумаге определяется, какую задачу бот закрывает.",
        steps: [
            {
                t: "Определение задачи",
                time: "2–4 дня",
                d: "Решаем, что именно закрывает бот: заявки, продажи, внутренний процесс или поддержку. Часто именно здесь выясняется, что нужна лишь половина задуманных функций, а остальное — лишнее.",
            },
            {
                t: "Сценарий и тексты",
                time: "3–6 дней",
                d: "Рисуем путь пользователя: какая кнопка что делает, какое сообщение приходит, что происходит при ошибке. Тексты готовятся на двух языках, и после вашего утверждения идём дальше.",
            },
            {
                t: "Разработка",
                time: "1–4 недели",
                d: "Собираем бота, базу данных и админ-панель. Каталог, корзина и роли пишутся на этом этапе. Каждую неделю вы сами пробуете работающую версию.",
            },
            {
                t: "Оплата и интеграции",
                time: "3–10 дней",
                d: "Подключаем Payme или Click, настраиваем обмен с CRM и 1С. Платёжные системы требуют договора и проверки — обычно именно этого приходится ждать дольше всего.",
            },
            {
                t: "Тестирование и запуск",
                time: "3–5 дней",
                d: "Бот размещается на сервере, включаются webhook и мониторинг. Сначала его пробует небольшая группа, ошибки правятся, затем бот открывается всем клиентам.",
            },
            {
                t: "Наблюдение и доработка",
                time: "6 месяцев",
                d: "В первые недели смотрим, на каком шаге люди останавливаются. По статистике упрощаем меню, правим тексты и бесплатно устраняем ошибки.",
            },
        ],
    },

    samples: {
        eyebrow: "Примеры",
        h: "Боты и системы, которые мы построили",
        sub: "Каждый проект с нуля: сценарий, админ-панель и интеграции сделаны нами.",
        cta: "Все проекты",
        slugs: ["grandpharm", "tezlift", "besh-market-app", "firewise"],
    },

    faq: {
        eyebrow: "Вопросы и ответы",
        h: "Частые вопросы",
        sub: "Короткие ответы на самые частые вопросы о Telegram-ботах.",
        items: [
            {
                q: "Сколько стоит разработка Telegram-бота?",
                a: "Цены начинаются от 9 000 000 сум. В эту сумму входят кнопочное меню, информационные разделы, приём заявок, массовая рассылка и админ-панель. Если добавить каталог, корзину, оплату Payme или Click и интеграцию с CRM, стоимость начинается от 24 000 000 сум. Mini App и многоролевые боты считаются по договорённости.",
            },
            {
                q: "За сколько времени будет готов бот?",
                a: "Тариф Start запускается за 2–3 недели, Business — за 4–7 недель. Это наша самая быстрая услуга. Срок чаще растягивает не разработка, а подключение оплаты: Payme и Click требуют договора и проверки, это занимает 3–10 дней. Чем быстрее вы утверждаете тексты, тем раньше проект закрывается.",
            },
            {
                q: "Есть ли ежемесячная плата за бота?",
                a: "Использование Telegram-ботов бесплатно — Telegram не берёт денег ни за бота, ни за отправленные сообщения. Единственный постоянный расход — сервер, на котором работает бот: для обычного бота это обычно 150–400 тысяч сум в месяц. Если внутри бота идёт оплата, комиссия Payme или Click считается отдельно.",
            },
            {
                q: "Можно ли принимать оплату Payme и Click внутри бота?",
                a: "Да, это входит в тариф Business. Клиент не покидает бота: подтверждает корзину, открывает окно оплаты, и после прохождения платежа статус заказа обновляется автоматически. Данные карты не попадают на ваш сервер — они остаются в платёжной системе. Работы по подключению входят в цену, комиссия платится провайдеру напрямую.",
            },
            {
                q: "Можно ли связать бота с CRM или 1С?",
                a: "Да. Заказ из бота попадает в CRM как сделка, а в карточку клиента записывается история общения. Из 1С в бота передаются остатки и цены — тогда отсутствующий товар просто не показывается. С Google Sheets тоже работаем, если CRM пока нет и таблицы достаточно.",
            },
            {
                q: "Чем Telegram Mini App отличается от обычного бота?",
                a: "Обычный бот работает кнопками и сообщениями — это быстро, но большой каталог так смотреть неудобно. Mini App — полноценный веб-интерфейс, который открывается внутри бота: каталог с фото, фильтры, корзина и оплата на одном экране. Если товаров больше сотни или выбор сложный, рекомендуем Mini App.",
            },
            {
                q: "Скольким людям можно отправить рассылку через бота?",
                a: "Ограничение не в числе подписчиков, а в скорости: Telegram пропускает примерно 30 сообщений в секунду, поэтому рассылка на 10 тысяч подписчиков идёт несколько минут. Наша система ставит их в очередь и отправляет постепенно. Важное предупреждение: если пользователи жалуются на спам, Telegram может ограничить бота.",
            },
            {
                q: "Что умеет внутренний бот для сотрудников?",
                a: "Заявления на отпуск и аванс, ежедневный отчёт, распределение задач, отметку посещаемости, запрос товара со склада и оперативную статистику для руководителя. Плюс в том, что сотруднику не нужно осваивать новую программу — он и так в Telegram. Доступ настраивается по ролям: кто что видит и подтверждает, решаете вы.",
            },
            {
                q: "Может ли бот заменить сайт?",
                a: "Для старта — да, особенно если ваши клиенты в Telegram и Instagram. Но бот не виден в поиске Google и не приносит бесплатный трафик. Сайт же придаёт компании официальный вид и годами приводит клиентов. Поэтому бот не заменяет сайт — многие наши клиенты используют оба на одной базе.",
            },
            {
                q: "Когда Telegram-бот не нужен?",
                a: "Если аудитории нет — ни подписчиков, ни базы клиентов, ни рекламного потока — бот будет стоять пустым, потому что сам он клиентов не приводит. Также если выбор товара требует долгой консультации или каждая сделка держится на индивидуальных условиях, бот закроет только первый контакт, но не продажу.",
            },
        ],
    },

    cta: {
        h: "Какую задачу должен закрыть ваш бот?",
        p: "На бесплатной консультации вместе определим, что можно автоматизировать ботом, уберём лишние функции и письменно зафиксируем точную цену и срок. Без обязательств. Телефон: +998 90 954 12 62.",
        button: "Получить бесплатную консультацию",
        secondary: "Написать в Telegram",
    },

    images: [
        {
            src: "/assets/img/projects/grandpharm.webp",
            alt: "Telegram-бот и логистическая система Grandpharm в одной экосистеме",
            caption: "Grandpharm — Telegram-бот, маршрутизация и внутренняя система управления работают на одной базе.",
        },
        {
            src: "/assets/img/projects/tamamuzbot.webp",
            alt: "Telegram-бот Tamam uz — каталог, корзина и экран оформления заказа",
            caption: "Tamam uz — каталог, корзина и оформление заказа полностью внутри бота.",
        },
        {
            src: "/assets/img/projects/aslamboi-uc-bot.webp",
            alt: "Онлайн-оплата и автоматическая выдача в Telegram-боте Aslamboi UC",
            caption: "Aslamboi UC — оплата закрывается внутри бота, а заказ выполняется автоматически.",
        },
        {
            src: "/assets/img/services/telegram-bot-admin-panel.webp",
            alt: "Админ-панель Telegram-бота: список заказов, статистика и раздел рассылки",
            caption: "Админ-панель — заказы, товары, статистика подписчиков и рассылка по сегментам.",
            prompt:
                "Clean modern web admin dashboard for a Telegram bot, light interface with soft blue accents, left sidebar navigation with icons, main area showing a table of incoming orders with status badges, a small line chart of daily active users, and a broadcast composer panel on the right. Realistic UI screenshot style, crisp typography, no readable brand names, 16:10 aspect ratio.",
        },
        {
            src: "/assets/img/services/telegram-bot-mini-app.webp",
            alt: "Интерфейс Telegram Mini App — каталог товаров с фото и корзина внутри бота",
            caption: "Telegram Mini App — полноценный магазин внутри бота: фильтры, корзина и оплата.",
            prompt:
                "Smartphone mockup showing a Telegram Mini App opened inside the messenger: a product catalogue grid with photo cards, price tags, category filter chips at the top and a floating cart button at the bottom. Telegram-style blue header bar, clean minimal e-commerce UI, realistic phone screen render on a neutral studio background, vertical composition.",
        },
    ],

    related: ["crm-tizimlar", "ai-agent", "internet-dokonlar", "biznes-avtomatlashtirish"],
};

const content = { uz, ru };

export default content;
